// @ts-nocheck
import { createApp } from 'vue'
import App from './App.vue'
import MM from './mm'
import http from './mm/http.js'
import router from './router'
import './assets/scss/onlyThis.scss'
import './assets/scss/index.scss'
import '@/kshIcon/iconfont.css'
import '@/kshIcon/iconfont.js'
import store from './store/index'
import {getCurrentLanguage, getCurrentPageId, getCurrentPageType, initAuthInfo} from './utils.js'
import { templateInfoApi, pageInfoApi } from './api/pageInfo.js'
import {updateRootStyle, walkNode} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import './globalPopagation.js'
import { getDefaultGlobalPopagationValues } from '@/globalPopagation'
import { MemoryMonitor } from './watchMomery.js'
import {batchLoadNodesSource} from './staticSource.js'
import './components/common/controlBar/controlBarDialog/event/index.js'

const app = createApp(App)

MM(app)
// 全局指令
app.directive('auth', {
  mounted(el, binding) {
    const key = binding.value
    if (!mm.store.state.authList.find((v) => v.key === key)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
  updated(el, binding) {
    const key = binding.value
    if (!mm.store.state.authList.find((v) => v.key === key)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})

const monitor = new MemoryMonitor()
monitor.start()

start()

async function start() {

  var [fontRes, authInfoRes, pageListRes] = await Promise.all(
    [
      http({
        url: '/api/font/list',
        method: 'get',
        loading: true
      }),
      http({
        url: '/ksh/auth/info',
        method: 'get',
        loading: true
      }),
      http({
        url: '/api/page/list',
        method: 'get',
        loading: true
      })
    ]
  )

  const { list: fontList = [] } = fontRes.data
  localStorage.setItem('fontList', JSON.stringify(fontList))


  const { info = {} } = authInfoRes.data
  if (info && info.rule == 'user') {
    mm.storage.set('SelectTemplateId', info.foreign_id)
  }
  initAuthInfo(info, fontList, store)

  if(info.type === 'member') {
    const menuRes = await http({
      url: '/ksh/getPanelMenuByUser',
      method: 'get',
      loading: false
    })
    const { list: authList = [] } = menuRes.data
    store.commit('UPDATE_AUTH_LIST', authList)
  }



  store.state.currentLanguage = getCurrentLanguage(store.state.authInfo.main_langset_id)

  var pageList = pageListRes.data.list

  if (store.state.authInfo.type === 'module') {
    var res = await http({
      url: '/api/module/info',
      method: 'get',
      loading: true,
      params: {
        id: store.state.authInfo.foreign_id
      }
    })
    res.data = res.data || {
      info: {
        content: undefined
      }
    }
    res.data.info.content = (() => {
      if (res.data.info.content) {
        if(typeof res.data.info.content === 'object'){
          return res.data.info.content
        }else{
          return JSON.parse(res.data.info.content)
        }
      } else {
        return []
      }
    })()
    store.state.module.currentModule = res.data.info
    store.state.module.currentPage = res.data.info
  } else if (store.state.authInfo.type === 'template') {
    const params = {
      a_ksh_template_id: store.state.authInfo.foreign_id,
      page_id: getCurrentPageId(),
      page_type: getCurrentPageType(getCurrentPageId(), pageList)
    }
    const res = await templateInfoApi(params)

    store.state.module.currentPage = res.data.info
    // store.state.globalFont = res.data.info.a_ksh_font_id ? res.data.info.a_ksh_font_id : 68
  } else {
    const params = {
      page_id: getCurrentPageId(),
      page_type: getCurrentPageType(getCurrentPageId(), pageList)
    }
    let res = await pageInfoApi(params)

    if(res.data.code === 20001){
      res = res.data
    }

    function resolveNode(node){
      if(
        node.startNode && (
          node.componentName === 'module' ||
          node.componentName === 'foot_module'  ||
          node.componentName === 'head_one' ||
          node.componentName === 'head_two' ||
          node.componentName === 'head_pc_one'
        )
      ){
        node.isCustomModule = true
      }
    }


    walkNode(res.data.info.header_content, (walkedNode)=>{
      resolveNode(walkedNode)
    })
    walkNode(res.data.info.content, (walkedNode)=>{
      resolveNode(walkedNode)
    })
    walkNode(res.data.info.footer_content, (walkedNode)=>{
      resolveNode(walkedNode)
    })

    store.state.module.currentPage = res.data.info
    // store.state.globalFont = res.data.info.a_ksh_font_id ? res.data.info.a_ksh_font_id : 68
  }
  if(store.state.module.currentPage?.header_content?.list?.length){
    await batchLoadNodesSource(store.state.module.currentPage.header_content)

  }else{
    await batchLoadNodesSource( ({
      name: '头部',
      startNode: true,
      componentName: 'head',
      _type: 'headBase',
      list: [
        {
          name: '空白模块',
          tips: '可拖入控件到此位置',
          componentName: 'module',
          _type: 'module1',
          startNode: true,
          id: 'id_0_0',
          list: [
            {
              name: '一行一列',
              _type: 'widgets_rowCol1',
              componentName: 'rowCol2',

              id: 'id_0_0_0',
              diffWidth: ['p1-0', 's1-0'],
              changeWidth:false,
              list: [
                {
                  name: '列',
                  componentName: 'col',
                  _width: '100'
                }
              ]
            }
          ]
        }
      ]
    }))
  }


  if(store.state.module.currentPage?.content?.list?.length){
    await batchLoadNodesSource(store.state.module.currentPage.content)

  }else{
    await batchLoadNodesSource(  ({
      name: '页面',
      startNode: true,
      componentName: 'content',
      _type: 'bodyBase',
      list: [
        {
          name: '空白模块',
          tips: '可拖入控件到此位置',
          componentName: 'module',
          _type: 'module1',
          startNode: true,
          id: 'id_1_0',
          list: [
            {
              name: '一行一列',
              _type: 'widgets_rowCol1',
              componentName: 'rowCol2',

              changeWidth:false,
              id: 'id_1_0_0',
              diffWidth: ['p1-0', 's1-0'],
              list: [
                {
                  name: '列',
                  componentName: 'col',
                  _width: '100'
                }
              ]
            }
          ]
        }
      ]
    }) )
  }

  if(store.state.module.currentPage?.footer_content?.list?.length){
    await batchLoadNodesSource(store.state.module.currentPage.footer_content)

  }else{
    await batchLoadNodesSource(  ({
      name: '底部',
      startNode: true,
      componentName: 'foot',
      _type: 'footBase',
      list: [
        {
          name: '空白模块',
          tips: '可拖入控件到此位置',
          componentName: 'module',
          startNode: true,
          _type: 'module1',
          id: 'id_2_0',
          list: [
            {
              name: '一行一列',
              _type: 'widgets_rowCol1',
              componentName: 'rowCol2',

              changeWidth:false,
              id: 'id_2_0_0',
              diffWidth: ['p1-0', 's1-0'],
              list: [
                {
                  name: '列',
                  componentName: 'col',
                  _width: '100'
                }
              ]
            }
          ]
        }
      ]
    }) )
  }
  app.use(store).use(router).mount('#app')
}

export default start
